export const GET_MY_WALLETS_START = 'GET_MY_WALLETS_START';
export const GET_MY_WALLETS_SUCCESS = 'GET_MY_WALLETS_SUCCESS';
export const GET_MY_WALLETS_ERROR = 'GET_MY_WALLETS_ERROR';
export const GET_MY_WALLETS_END = 'GET_MY_WALLETS_END';
